import "./style.scss"
import React, { Component } from 'react'
import Flag from "react-flags";
import logic from './logic'


@logic
export default class LanguageIcon extends Component {
  render() {
    const { language, visible } = this.props;

    if(!visible) {
      return null;
    }

    return (
      <Flag
        className={'label-language-icon'}
        name={ language.country }
        format="png"
        shiny={true}
        pngSize={32}
        width={16}
        height={16}
        basePath={"/assets/img/flags"}
      />
    )
  }
}
